<template>
  <div class="ushk-flash">
    <skeleton v-if="!datas.length" />
    <div id="J_flash_list" class="ushk-flash_list">
      <ushk-message-group v-if="datas.length" :datas="renderDatas" />
    </div>
    <div class="ushk-more">
      <a
        v-if="datas.length"
        @click="lower"
        class="ushk-more__btn"
        :class="{ 'is-loading': isLoading }"
        href="javascript:;"
      >
        <i class="ushk-icon ushk-icon_expand"></i>点击加载更多</a
      >
    </div>
  </div>
</template>

<script>
import UshkMessageGroup from './MessageGroup'
import { fetch } from '@/commons/fetch'
import { addCss, dateFormat } from '@/commons/utils'
import { requestUrl } from '@/commons/config'
import { filterData, filterTag } from './filter'
import Socket from '@/plugins/socket'
import sound from './sound'
import flashNotification from './push'
import vuexTools, { createNamespacedHelpers } from 'vuex'
const { mapActions, mapGetters } = createNamespacedHelpers('calendar')
let $socket = null

export default {
  name: '',
  components: {
    UshkMessageGroup
  },
  props: {
    isOpenVoice: Boolean,
    isOpenNotice: Boolean,
    onlyImportant: Boolean,
    currentChannel: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters(['stockAffect']),
    renderDatas () {
      if (this.onlyImportant) {
        const data = {}
        Object.keys(this.filteredDatas).forEach((key) => {
          data[key] = this.filteredDatas[key].filter((item) => {
            return item.type === 0 ? item.important : item.data.star >= 3
          })
        })
        return data
      } else {
        return this.filteredDatas
      }
    }
  },
  watch: {
    currentChannel () {
      // console.log(this.currentChannel);

      this.channel = this.currentChannel ? this.currentChannel : null
      // this.lastID = null;

      // console.log(this.datas);
      this.datas = []
      this.filteredDatas = {}
      this.getData({
        params: {
          max_time: undefined,
          channel: this.channel
        }
      })
    }
  },
  data () {
    return {
      datas: [],
      filteredDatas: {},
      lastID: undefined,
      isLoading: false,
      curImportantRelevance: '',
      channel: 0,
      irFirstConnect: true
    }
  },
  created () {
    this.getStockAffect().then(() => {
      this.render()
      this.init()
    })
  },
  // mounted () {
  //   addCss('https://ushknews.com/assets/fonts/font.css')
  // },
  methods: {
    ...mapActions(['getStockAffect']),
    init () {
      this.socket()

      window.testUpdate = this.update
    },
    socket () {
      let _this = this
      window.Jin10FlashInstance = new Jin10USFlash({
        conectedCallback (socket) {
          console.log('conectedCallback', socket)
        },
        // 如果需要展示快讯列表此时请通过接口获取最新快讯,first表示是否为第一次回调,后续回调是因为断开重连,决定是否需要再次获取快讯覆盖。注：请return Promise函数，不执行不要传，会阻塞
        // getFlashListCallback({ first }) {
        //   console.log("getFlashListCallback", first);
        // },
        // 原来是其他频道，修改后是当前频道，此时等同于接收到新快讯，只是时间上不一定是插入到第一条,  当前频道通过window.jin_us_flash_channel获取,所以得设好全局变量,每次切换频道时修改
        modifyChanelAddCallback (datas) {
          console.log('modifyChanelAddCallback', datas)
          _this.handleData(datas)
        },
        // 接收到新快讯(建议在列表中取前n条快讯,找不到相同id的才加)
        addCallback (datas) {
          console.log('addCallback', datas)
          _this.handleData(datas)
        },
        // 接收到修改快讯(建议在列表中查找,找到才改)
        modifyCallback (datas) {
          console.log('modifyCallback', datas)
          _this.handleData(datas)
        },
        // 接收到删除快讯(建议在列表中查找,找到才删)
        delCallback (datas) {
          console.log('delCallback', datas)
          _this.handleData(datas)
        },
        // 接收到刷新页面的请求
        reloadCallback (datas) {
          console.log('reloadCallback', datas)
          _this.handleData(datas)
        },
        // 接收到消息就调用，需要自己判断消息类型，如果是快讯还需要判断频道区分不同的情况
        // type已有flash、event，type===''则是新的消息类型
        allMessageCallback ({ opcode, type, datas, buf }) {
          // if(window.jin_us_flash_channel === datas.channel && datas.channel[0]) {
          //   let channel = [window.jin_us_flash_channel]
          //   console.log("allMessageCallback", channel, datas, _this.channel);
          //   if (!_this.channel) {
          //     _this.update(datas);
          //   } else if ((channel || []).indexOf(parseInt(_this.channel)) > -1) {
          //     _this.update(datas);
          //   }
          // }
        }
      })
    },
    handleData (data) {
      let {channel} = data
      if (!this.channel) {
        this.update(data)
      } else if ((channel || []).indexOf(parseInt(this.channel)) > -1) {
        this.update(data)
      }
    },
    getData (payload = {}) {
      return new Promise((resolve, reject) => {
        // payload.channel = !this.channel ? '' : this.channel,
        this.isLoading = true
        fetch({
          url: 'https://flash-api.ushknews.com/get_flash_list_with_channel',
          params: payload.params || {
            max_time: this.lastID,
            channel: !this.channel ? '' : this.channel
          },
          type: 'get',
          useJson: true,
          headers: {
            'x-version': '1.0.0',
            'x-app-id': 'brCYec5s1ova317e'
          },
          callback: (res) => {
            this.isLoading = false
          },
          success: (res) => {
            const datas = res.data
            // let action = payload.isUpdate ? "unshift" : "push";
            if (!datas.length) {
              return false
            }

            datas.forEach((data) => {
              let action = payload.isUpdate ? 'unshift' : 'push'
              if (this.datas.findIndex((item) => item.id === data.id) !== -1) {
                return false
              }
              if (data.type === 0 && data.data.lock) {
                return false
              }
              data = filterData(data, false, this.stockAffect)
              const date = data.date
              if (!Object.keys(this.filteredDatas).length) {
                this.generateDate(date)
              }
              // 下拉加载时判断该消息是否是选中状态
              if (
                payload.isLower &&
                this.curImportantRelevance &&
                data.type === 0 &&
                data.relevance === this.curImportantRelevance
              ) {
                data = { ...data, isRelevanceImportant: true }
              }
              if (!this.filteredDatas[date]) {
                this.$set(this.filteredDatas, date, [])
                // filteredDatas[date] = []
              }
              if (payload.isUpdate) {
                this.updateData(data, date)
              } else {
                this.filteredDatas[date].push(data)
              }
              this.datas[action](data)
            })
            resolve(this.filteredDatas)
          },
          error: () => {
            this.isLoading = false
          }
        })
      })
    },
    render () {
      this.getData()
    },
    generateDate (nowDate) {
      nowDate = nowDate.replace(/-/g, '/')
      const nowTime = new Date(nowDate).getTime()
      const dayTime = 86400000
      for (let i = 30; i >= 0; i--) {
        const date = dateFormat(new Date(nowTime + dayTime * i), 'yyyy-MM-dd')
        this.$set(this.filteredDatas, date, [])
      }
    },
    sliceDate (dateId) {
      const y = dateId.slice(0, 4)
      const m = dateId.slice(4, 6)
      const d = dateId.slice(6, 8)
      return `${y}-${m}-${d}`
    },
    update (data) {
      const { type, action, id, channel } = data
      const date = id ? this.sliceDate(id) : ''
      const datas = this.filteredDatas[date]
      const index = datas
        ? datas.findIndex((item) => {
          return item.id === id
        })
        : 0
      if (action && action !== 1) {
        if (index === -1) {
          return false
        }
        if (action === 2) {
          if (data.data) {
            const curData = datas[index]
            const fData = filterData(
              Object.assign({}, curData, data),
              true,
              this.stockAffect
            )
            this.$set(this.filteredDatas[date], index, fData)
          }
        } else if (action === 3) {
          this.$delete(this.filteredDatas[date], index)
        } else if (action === 6) {
          const time = Math.floor(Math.random() * 30 + 1) - 1
          setTimeout(function () {
            window.location.reload()
          }, time * 1000)
        }
        return false
      }
      if (index !== -1) {
        return false
      }
      data = filterData(data, true, this.stockAffect)
      this.datas.unshift(data)
      if (
        data.type === 0 &&
        data.relevance === this.curImportantRelevance &&
        this.curImportantRelevance
      ) {
        data = { ...data, isRelevanceImportant: true }
      }
      if (!this.filteredDatas[date]) {
        this.$set(this.filteredDatas, date, [])
      }
      this.updateData(data, date)
      if (this.isOpenVoice) {
        sound.play()
      }
      if (!this.isOpenNotice || !data.important) {
        return false
      }
      const notificationTitle =
        '美港电讯 - ' + location.origin.replace('https://', '')
      let notificationOptions = {
        timeout: 8000,
        onClick: function () {
          window.focus()
          this.close()
        }
      }
      if (data.type == 0) {
        notificationOptions.icon = data.data.pic
          ? data.data.pic
          : location.origin + '/img/notice-icon.png'
        notificationOptions.body = data.data.content
          .replace(/<br \/>/gi, '\n')
          .replace(/<[^>]+>/g, '')
      } else {
        notificationOptions.icon =
          '//cdn.jin10.com/assets/img/commons/flag/flash/' +
          data.data.country +
          '.png'
        notificationOptions.body =
          data.time_view +
            ' ' +
            data.data.content +
            '\n前值：' +
            data.data.previous ||
          '' + ' 预期：' + data.data.consensus ||
          '' + ' 实际：' + data.data.actual ||
          '' + '\n解读：理论上较为【' + data.data.evaluate + '】股票价格'
      }
      flashNotification.create(notificationTitle, notificationOptions)
    },
    updateData (data, date) {
      const { id } = data
      const datas = this.filteredDatas[date]
      if (datas.length) {
        for (let i = 0, l = datas.length; i < l; i++) {
          if (id > datas[i].id) {
            this.filteredDatas[date].splice(i, 0, data)
            break
          }
        }
      } else {
        this.filteredDatas[date].push(data)
      }
    },
    lower () {
      this.lastID = this.datas[this.datas.length - 1].time
      this.getData({ isLower: true })
    },
    mouseHandle (curImportantRelevance) {
      this.curImportantRelevance = curImportantRelevance
    }
  }
}
</script>



// WEBPACK FOOTER //
// FlashList.vue?674657a1